
(function(){
  const KEY='dcs-recent-products';
  function get(){
    try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}
  }
  function save(items){
    localStorage.setItem(KEY,JSON.stringify(items.slice(0,12)));
  }

  document.addEventListener('DOMContentLoaded',()=>{
    const productData=document.querySelector('[data-current-product]');
    if(productData){
      const item={
        handle:productData.dataset.handle,
        title:productData.dataset.title,
        url:productData.dataset.url,
        image:productData.dataset.image,
        price:productData.dataset.price,
        available:productData.dataset.available==='true'
      };
      let items=get().filter(x=>x.handle!==item.handle);
      items.unshift(item); save(items);
    }

    document.querySelectorAll('[data-recently-viewed]').forEach(root=>{
      const current=root.dataset.currentHandle||'';
      const items=get().filter(x=>x.handle!==current && x.available!==false).slice(0,6);
      if(!items.length){root.closest('.recently-viewed-section')?.remove(); return;}
      root.innerHTML=items.map(item=>`
        <article class="card recent-card">
          <a href="${item.url}">
            <div class="recent-card__image">${item.image?`<img src="${item.image}" alt="">`:''}</div>
            <div class="recent-card__body">
              <h3>${item.title}</h3>
              <strong>${item.price}</strong>
            </div>
          </a>
        </article>`).join('');
    });
  });
})();
